import * as React from 'react';

import { ICurrency } from '@containers/App/model';

import { Line } from '../SelectedVariant/styled';

import {
  ConditionalVoucherDiscount,
  IConditionalVoucherDiscount,
} from './ConditionalVoucherDiscount';
import { VoucherDiscountContext } from './context';
import { LineWrapper } from './styled';
import { IVoucherDiscount, VoucherDiscount } from './VoucherDiscount';

interface IVoucherDiscountProps {
  voucherDiscount: IVoucherDiscount | IConditionalVoucherDiscount;
  currency: ICurrency;
  isUnderSelectBox?: boolean;
  hideLine?: boolean;
  isArrowHidden?: boolean;
}

export const VoucherDiscountMaster = ({
  voucherDiscount,
  hideLine,
  ...rest
}: IVoucherDiscountProps) => {
  return (
    <VoucherDiscountContext.Provider value={{ ...rest }}>
      {isConditionalDiscount(voucherDiscount) ? (
        <ConditionalVoucherDiscount voucherDiscount={voucherDiscount} />
      ) : (
        <VoucherDiscount voucherDiscount={voucherDiscount} />
      )}

      {!hideLine && (
        <LineWrapper>
          <Line dashedLine={true} />
        </LineWrapper>
      )}
    </VoucherDiscountContext.Provider>
  );
};

const isConditionalDiscount = (
  discount: IConditionalVoucherDiscount | IVoucherDiscount
): discount is IConditionalVoucherDiscount => {
  return 'discountConditions' in discount;
};
